<div class="my-remax-container flex-one">
  <div class="is-flex navigation has-pos-rel">
    <div class="flex-one is-flex has-flex-align-center " (click)="home()">
      <i class="material-icons">keyboard_arrow_left</i>
      {{ 'my-remax.back-to-search' | translate }}
    </div>
    <div class="hide-on-desktop-down">
      <app-bread-crumbs [breadcrumbs]="breadcrumbs"></app-bread-crumbs>
    </div>
  </div>
  <div class="my-remax-content">
    <ul class="nav nav-tabs">
      <li role="presentation" [class.active]="myRemaxMode === MyRemaxModes.FAVOURITES" (click)="showFavourites()" class="text-center tab">
        <a translate="my-remax.saved-listings"></a>
      </li>
      <li role="presentation" [class.active]="myRemaxMode === MyRemaxModes.SAVED_SEARCHES" (click)="showSavedSearches()" class="text-center tab">
        <a translate="my-remax.saved-searches.title"></a>
      </li>
    </ul>
    <app-favourite-listings class="flex-one" [class.hidden]="myRemaxMode !== MyRemaxModes.FAVOURITES" (wentToFindSome)="home()"></app-favourite-listings>
    <app-saved-searches class="is-flex is-flex-column flex-one" [class.hidden]="myRemaxMode !== MyRemaxModes.SAVED_SEARCHES" (onDeleteAllClick)="deleteAllSavedSearches()"
    (onSaveChangesClick)="updateNotificationEnabledOnSavedSearches($event)"
    [class.no-saved-searches]="!savedSearches.length"
    (onDeleteSavedSearchClick)="deleteSavedSearch($event)" (onSavedSearchClick)="restoreSavedSearch($event)"
    (onStartSearchClick)="startSavedSearch()" [savedSearches]="savedSearches"></app-saved-searches>
  </div>
  <app-login-reminder></app-login-reminder>
  <app-notifications></app-notifications>
  <app-changes-saved *ngIf="showChangesSaved" (onClose)="showChangesSaved = false" ></app-changes-saved>
</div>
